import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import { prepareNum, unitLabel } from '@services/helper.service';
import { APP_TEXTS } from '../../../../../texts/texts';

import './../styles.scss';
import { BRAND } from '@config';
import { brandList } from '../../../../../app.values';

class ResultsOfDesignMasonry extends React.Component {

	constructor(props) {
		super(props);

		this.prepareValue = props.prepareValue;
	}

	render() {
		return (
		<div className="calculation">
				{this.props.selectedItem && (
				<section className="list-type calculate-results-of-design">
				<Table bordered size="sm">
          <thead>
            <tr>
              <th>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_TENSION.Content}</th>
              <th>{unitLabel(this.props.loadUnit)}</th>
              <th>&beta;<sub>N</sub>&nbsp;=</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">
              <div className="d-flex">
                  <span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_PULL_THROUGH_CAPACITY_PER_ANCHOR.Content}</span>
                  {BRAND === brandList["Ramset"] ? (
                    <span>N<sub>a</sub></span>
                  ) : (
                    <span>N<sub>Rd,c</sub></span>
                  )}
              </div>
              </th>
                  <td>{this.props.selectedItem.BetaN_Masonry > 0 ? this.prepareValue(this.props.selectedItem.NRd) : "***"}</td>
                  <td>{prepareNum(this.props.selectedItem.BetaN_Masonry, true, 2, true)}</td>
            </tr>
          </tbody>
				</Table>
		
				<Table bordered size="sm">
          <thead>
            <tr>
              <th>{APP_TEXTS.CALCULATE_HEADER_SHEAR.Content}</th>
              <th>{unitLabel(this.props.loadUnit)}</th>
              <th>&beta;<sub>V</sub>&nbsp;=</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">
              <div className="d-flex">
                <span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_SHEAR_CAPACITY_PER_ANCHOR.Content}</span>
                  {BRAND === brandList["Ramset"] ? (
                    <span>V<sub>a</sub></span>
                  ) : (
                    <span>V<sub>Rd,c</sub></span>
                  )}
              </div>
              </th>
              <td>{this.props.selectedItem.BetaV_Masonry > 0 ? this.prepareValue(this.props.selectedItem.VRd) : "***"}</td>
              <td>{prepareNum(this.props.selectedItem.BetaV_Masonry, true, 2, true)}</td>
            </tr>
          </tbody>
				</Table>
		
				<Table bordered size="sm">
          <tbody>
            <tr>
              <th scope="row">
                <div className="d-flex">
                  <span>{APP_TEXTS.CALCULATE_RESULTS_DESGIN_UTILIZATION_EQUATION.Content}</span>
                  {this.props.selectedItem.BetaN_Masonry > 0 && this.props.selectedItem.BetaV_Masonry > 0 ? (
                    <span className="utilization">
                      &beta;<sub>N</sub>&nbsp;+&nbsp;&beta;<sub>V</sub>&nbsp;&le;&nbsp;1.0&nbsp;
                    </span>
                  ) : (this.props.selectedItem.BetaN_Masonry > 0 ? (
                    <span className="utilization">
                      &beta;<sub>N</sub>&nbsp;&le;&nbsp;1.0&nbsp;
                    </span>
                  ) : (
                    <span className="utilization">
                      &beta;<sub>V</sub>&nbsp;&le;&nbsp;1.0&nbsp;
                    </span>
                  ))}
                </div>
              </th>
              <td>{prepareNum(this.props.selectedItem.Beta, true, 2, true)}</td>
            </tr>
          </tbody>
				</Table>
				</section>
				)}
		</div>
		);
	}
    
}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
    return {
      selectedItem: data.gridSelectedItem,
      loadUnit: state.main.units.load,
    };
  }

  return {};
};
  
const mapDispatch = dispatch => ({
});
  
export default connect(mapState, mapDispatch)(ResultsOfDesignMasonry);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateResultsOfDesign/components/ResultsOfDesignMasonry.js